var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.collapse)?_c('div',{staticClass:"sidebar"},[(!_vm.collapse)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.closePanel}}):_vm._e(),_c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }